import application from "../assets/small-card-icons/application.png";
import communication from "../assets/small-card-icons/communication.png";
import durability from "../assets/small-card-icons/durability.png";
import format from "../assets/small-card-icons/format.png";
import meterology from "../assets/small-card-icons/meterology.png";
import photographs from "../assets/small-card-icons/photographs.png";
import trap from "../assets/small-card-icons/trap.png";

// these cards are shown on the homepage
export const SmallCardsList = [
  {
    icon: trap,
    title: "home.content.cards.child.1.title",
    description: "home.content.cards.child.1.description",
  },
  {
    icon: application,
    title: "home.content.cards.child.2.title",
    description: "home.content.cards.child.2.description",
  },
  {
    icon: communication,
    title: "home.content.cards.child.3.title",
    description: "home.content.cards.child.3.description",
  },
  {
    icon: durability,
    title: "home.content.cards.child.4.title",
    description: "home.content.cards.child.4.description",
  },
  {
    icon: format,
    title: "home.content.cards.child.5.title",
    description: "home.content.cards.child.5.description",
  },
  {
    icon: photographs,
    title: "home.content.cards.child.6.title",
    description: "home.content.cards.child.6.description",
  },
  {
    icon: meterology,
    title: "home.content.cards.child.7.title",
    description: "home.content.cards.child.7.description",
  },
];
